mainApp.directive('typeahead', ['$sce','$document','IntervalService',function($interval,$sce,$document,IntervalService) {
    return {
        templateUrl: '/public/directives/typeahead.html',
        scope: {
          global:"@"
        },
        controller: ['$scope',function($scope) {
            $scope.searchExpanded = false;
            $scope.query = "";

            $scope.search = function() {
                var newQuery = $("#searchInput").val();
                if(!newQuery || $scope.query == newQuery){
                    $scope.query == newQuery;
                    return;
                }
                $scope.query = newQuery;
                store.fetch({
                    path: '/search',
                    queryParams: {"query": $scope.query},
                    success: function(data) {
                        $scope.items = data;
                        $("#searchResults").show();
                    }
                });

            }

        }],
        link:function($scope,element){

            $document.bind('click', function(e){
                var targetbox = $('#searchResults');
                if(!targetbox.is(e.target) && targetbox.has(e.target).length === 0){
                    $('#searchInput').val("");
                    $('#searchResults').fadeOut('fast');
                }
            });

            $("#searchButton").on("click", function(){
                $scope.search();
            });
            IntervalService.dynamicInterval($scope.search, $scope.$id, 'typeaHeadSearch', true);

            element.on('$destroy', function() {
                IntervalService.cancelDynamicInterval($scope.$id, 'typeaHeadSearch');
            });
            $("#searchResults").on("click", function(){
                $("#searchResults").hide();
            });
        }
    };
}]);
